<template>
    <div class="px-2">
        <div class="flex flex-wrap -mx-4">
            <div class="w-full sm:w-1 md:w-1 lg:w-1/3 xl:w-1/3 px-2" id="ingredient-container">

                <template>
                    <form>
                        <vx-card
                            :title="ingredient.id ? 'Edycja':'Dodaj nowy składnik'"
                            title-color="primary"
                            :subtitle="ingredient.id ? 'Aktualizuj obecny składnik':'Nowy składnik trafi do listy po prawej stronie'">

                            <div class="vx-row mb-2">
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" :disabled="(ingredient.is_global === 1)"
                                              label-placeholder="Nazwa składnika"
                                              v-model="ingredient.name" v-validate="'required'" name="name" oninput="this.value = this.value.toLowerCase()"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('name')">{{ errors.first('name') }}</span>

                                </div>
                            </div>
                            <div class="vx-row mb-2">
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" :disabled="(ingredient.is_global === 1)" type="text"
                                              label-placeholder="Producent"
                                              v-model="ingredient.manufacturer"
                                              name="manufacturer"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('manufacturer')">{{
                                            errors.first('manufacturer')
                                        }}</span>
                                </div>
                            </div>


                            <div class="vx-row mb-2">
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full" :disabled="(ingredient.is_global === 1)"
                                              label-placeholder="Kaloryczność (kcal)"
                                              v-model="ingredient.calorific" v-validate="'required'"
                                              type="number" name="calorific"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('calorific')">{{ errors.first('calorific') }}</span>
                                </div>
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full" :disabled="(ingredient.is_global === 1)"
                                              label-placeholder="Cukry proste (g)"
                                              v-model="ingredient.cukry_proste" v-validate="'required'"
                                              type="number" name="cukry_proste"/>
                                    <span class="text-danger text-sm" v-show="errors.has('cukry_proste')">{{
                                            errors.first('cukry_proste')
                                        }}</span>
                                </div>
                            </div>
                            <div class="vx-row mb-2">
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full" :disabled="(ingredient.is_global === 1)"
                                              label-placeholder="Tłuszcz (g)"
                                              v-model="ingredient.fat" v-validate="'required'"
                                              type="number" name="fat"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('fat')">{{ errors.first('fat') }}</span>
                                </div>
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full" :disabled="(ingredient.is_global === 1)"
                                              label-placeholder="Białko (g)"
                                              v-model="ingredient.protein" v-validate="'required'"
                                              type="number" name="protein"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('protein')">{{ errors.first('protein') }}</span>
                                </div>
                            </div>
                            <div class="vx-row mb-2">
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full" :disabled="(ingredient.is_global === 1)"
                                              label-placeholder="Kw.tł.nasycone (g)"
                                              v-model="ingredient.fat_saturated" v-validate="'required'"
                                              type="number" name="fat_saturated"/>
                                    <span class="text-danger text-sm" v-show="errors.has('fat_saturated')">{{
                                            errors.first('fat_saturated')
                                        }}</span>
                                </div>
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full" :disabled="(ingredient.is_global === 1)"
                                              label-placeholder="Sól (g)" v-model="ingredient.sol"
                                              type="number" name="sol" v-validate="'required'"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('sol')">{{ errors.first('sol') }}</span>
                                </div>
                            </div>
                            <div class="vx-row mb-2">
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full" :disabled="(ingredient.is_global === 1)"
                                              label-placeholder="Węglowodany (g)"
                                              v-model="ingredient.carbohydrates" v-validate="'required'"
                                              type="number" name="carbohydrates"/>
                                    <span class="text-danger text-sm" v-show="errors.has('carbohydrates')">{{
                                            errors.first('carbohydrates')
                                        }}</span>
                                </div>
                                <div class="vx-col w-full sm:w-1/2 w-full mb-2">
                                    <vs-input class="w-full" :disabled="(ingredient.is_global === 1)"
                                              label-placeholder="Błonnik (g)"
                                              v-model="ingredient.roughage" v-validate="'required'"
                                              type="number" name="roughage"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('roughage')">{{ errors.first('roughage') }}</span>
                                </div>
                            </div>
                            <div class="vx-row mb-2">
                                <div class="vx-col w-full sm:w-1/2 flex items-center pt-4">
                                    <vs-switch :disabled="(ingredient.is_global === 1)"
                                               v-model="ingredient.is_alergen"/>
                                    <span class="ml-4">Alergen</span>
                                </div>
                            </div>

                            <div class="vx-row mb-4">
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" :disabled="(ingredient.is_global === 1)"
                                              label-placeholder="Emulgatory"
                                              v-model="ingredient.emulgatory"
                                              name="emulgatory"/>
                                    <span class="text-danger text-sm"
                                          v-show="errors.has('emulgatory')">{{ errors.first('emulgatory') }}</span>
                                </div>
                            </div>

                            <div class="vx-row mb-8">
                                <div class="vx-col w-full">
                                    <div class="mt-4 mb-2" style="color:#999999">
                                        Składniki wewnętrzne:
                                    </div>
                                  <div class="vx-row mb-4">
                                    <div class="vx-col w-full">
                                      <div class="autocomplete-container">
                                        <vs-input class="w-full" label-placeholder="SZUKAJ/DODAJ (Wpisz nazwę składnika)" v-model="searchIngredient" v-on:keydown.enter.prevent="createChild"/>
                                        <div class="small-button" v-if="searchIngredient">
                                          <button class="border-none feather icon-delete small-button-clear" @click="clearSearch"></button>
                                          <button class="vs-button vs-button-primary vs-button-filled small-button-add" @click="createChild">dodaj</button>
                                        </div>
                                        <div v-if="searchIngredient" class="autocomplete">
                                          <div v-for="ingredient in filteredIngredients" :key="ingredient.id" @click="selectIngredient(ingredient)">
                                            {{ ingredient.name }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="ingredient.children_ingredients.length === 0">- brak -</div>
                                  <div v-else>
                                    <InternalIngredientsTree :items="ingredient.children_ingredients"></InternalIngredientsTree>
                                  </div>
                                </div>
                            </div>


                            <div class="vx-row">
                                <div class="vx-col w-full">
                                    <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                                               :disabled="(ingredient.is_global === 1)">
                                        {{ ingredient.id ? 'Aktualizuj' : 'Dodaj' }}
                                    </vs-button>
                                    <vs-button color="warning" type="border" class="mb-2"
                                               @click="resetForm">Wyczyść
                                    </vs-button>
                                </div>
                            </div>


                        </vx-card>
                    </form>
                </template>
            </div>
            <div class="w-full sm:w-1 md:w-1 lg:w-2/3 xl:w-2/3 px-2">


                <vx-card
                    title="Baza składników"
                    title-color="primary"
                    subtitle="Przeglądaj listę dostępnych składników ">

                    <vs-input class="w-1/2 mb-4" label-placeholder="Wyszukaj składnik"
                              v-model="search" placeholder="Wyszukaj składnik"/>

                  <div class="mb-2">
                    <vs-select label="filtr składników" v-model="ingredientFilter"  width="200px">
                      <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="item,index in ingredientFilters" />
                    </vs-select>
                  </div>

                    <vs-table v-model="selected" max-items="10" stripe :data="ingredients" id="ingredients-container">

                        <template slot="thead">
                            <vs-th>lp.</vs-th>
                            <vs-th>Nazwa produktu</vs-th>
                            <vs-th sort-key="calorific">kcal</vs-th>
                            <vs-th sort-key="protein">B</vs-th>
                            <vs-th sort-key="carbohydrates">W</vs-th>
                            <vs-th sort-key="fat">T</vs-th>
                            <vs-th>&nbsp;</vs-th>
                            <vs-th>&nbsp;</vs-th>
                            <vs-th>&nbsp;</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td :data="data[indextr].id">
                                    {{ indextr + 1 }}
                                </vs-td>

                                <vs-td :data="data[indextr].name">
                                    <vx-tooltip :text="getChildrenNames(data[indextr].children_ingredients)" v-if="data[indextr].children_ingredients.length">
                                        {{ data[indextr].name }}
                                    </vx-tooltip>
                                    <span v-if="!data[indextr].children_ingredients.length">{{
                                            data[indextr].name
                                        }}</span>
                                </vs-td>

                                <vs-td :data="data[indextr].calorific">
                                    {{ data[indextr].calorific }}
                                </vs-td>

                                <vs-td :data="data[indextr].protein">
                                    {{ data[indextr].protein }}
                                </vs-td>

                                <vs-td :data="data[indextr].carbohydrates">
                                    {{ data[indextr].carbohydrates }}
                                </vs-td>

                                <vs-td :data="data[indextr].fat">
                                    {{ data[indextr].fat }}
                                </vs-td>

                                <vs-td :data="data[indextr].id" class="text-center">
                                    <div class="fonticon-wrap">
                                        <i v-on:click="fetchOne(`${data[indextr].id}`)"
                                           class="feather icon-edit"></i>
                                    </div>
                                </vs-td>

                                <vs-td :data="data[indextr].id" class="text-center">
                                    <div class="fonticon-wrap" v-if="!data[indextr].is_global">
                                        <i v-on:click="deleteOne(`${data[indextr].id}`)"
                                           class="feather icon-delete"></i>
                                    </div>
                                </vs-td>

                                <vs-td :data="data[indextr].id" class="text-center">
                                    <vx-tooltip text="Dodaj jako składnik wewnętrzny">
                                        <div class="fonticon-wrap">
                                            <i v-on:click="addChild(data[indextr])"
                                               class="feather icon-plus-circle" style="color:#28C76F"></i>
                                        </div>
                                    </vx-tooltip>
                                </vs-td>
                            </vs-tr>
                        </template>

                    </vs-table>
                    <vs-pagination class="mt-4" :total="ingredientsCount" :max="10" v-model="ingredientsPage"
                                   goto></vs-pagination>

                </vx-card>


            </div>
        </div>
    </div>

</template>

<script>
import {Validator} from 'vee-validate';
import vSelect from 'vue-select'
import InternalIngredientsTree from '../../components/InternalIngredientsTree.vue'

const dict = {
    custom: {
        name: {
            required: 'Nazwa produktu jest wymagana',
        },
        cukry_proste: {
            required: 'Cukry są wymagane'
        },
        emulgatory: {
            required: 'Emulgatory są wymagany'
        },
        calorific: {
            required: 'Kaloryczność jest wymagana'
        },
        fat: {
            required: 'Tłuszcz jest wymagany'
        },
        protein: {
            required: 'Białko jest wymagane'
        },
        carbohydrates: {
            required: 'Węglowodany jest wymagane'
        },
        fat_saturated: {
            required: 'Tłuszcz nasycony jest wymagany'
        },
        roughage: {
            required: 'Błonnik jest wymagany'
        },
        sol: {
            required: 'Sól jest wymagana'
        },
    }
};

// register custom messages
Validator.localize('en', dict);
export default {
    data() {
        return {
            ingredientsPage: 1,
            ingredientsCount: 0,
            activeConfirm: false,
            colorAlert: 'primary',
            titleAlert: 'Alert',
            activeAlert: false,
            valueInput: '',
            selected: [],
            tableList: [
                'vs-th: Component',
                'vs-tr: Component',
                'vs-td: Component',
                'thread: Slot',
                'tbody: Slot',
                'header: Slot'
            ],
            alergen: true,
            alert: false,
            ingredient: {
                id: '',
                name: '',
                calorific: '',
                manufacturer: '',
                cukry_proste: '',
                fat: '',
                protein: '',
                fat_saturated: '',
                carbohydrates: '',
                roughage: '',
                sodium: '',
                emulgatory: '',
                sol: '',
                cholesterol: 0,
                is_alergen: false,
                is_global: false,
                children_ingredients: [],
            },
            search: '',
            ingredients: [],
            brief: [],
            isLoading: false,
            awaitingSearch: false,
            toDeleteId: 0,
            searchIngredient: '',
            createChildId: '',
            allIngredients: [],
            ingredientFilter: -2,
            ingredientFilters: [
              {value: -2, name: 'Moje składniki'},
              {value: -3, name: 'Składniki globalne'},
              {value: -4, name: 'Składniki wewnętrzne'}
              //{id: -1, name: 'Old Globalne składniki'},
            ],
            isLoadingAll: false,
        }
    },
    mounted() {
        this.fetchData();
        this.fetchAllData();
        this.fetchUser(this.activeUserInfo.id);
    },
    computed: {
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      },
      filteredIngredients() {
        return this.allIngredients.filter(ingredient =>
                ingredient.name.toLowerCase().includes(this.searchIngredient.toLowerCase())
            //&& (ingredient.is_old_global == 0)
        ).slice(0, 5);
      },
    },
    watch: {
        ingredientsPage: function () {
            this.fetchData();
        },
        search: function (a, b) {
            if (!this.isLoading) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.ingredientsPage = 1;
                    this.fetchIngredientsFiltered(a);
                    this.isLoading = true;
                }, 2000);
            }
        },
      ingredientFilter: function () {
          this.fetchIngredientsFiltered();
      }
    },
    methods: {
        clearSearch() {
          this.searchIngredient = '';
        },
        createChild(e) {
          e.preventDefault();
          if (this.searchIngredient.length) {
            this.createChildId = this.createChildId + '0';
            const ingredient = {
              id: this.createChildId,
              name: this.searchIngredient,
              cholesterol: 0,
              is_alergen: false,
              is_global: false,
              children_ingredients: [],
            };
            this.ingredient.children_ingredients.push(ingredient);
            this.clearSearch();
          }
          return false;
        },
        selectIngredient(ingredient) {
          this.ingredient.children_ingredients.push(ingredient);
          this.clearSearch();
        },
        getChildrenNames: function (children) {
            let out = [];
            for (let i in children) {
                out.push(children[i].name);
            }
            return out.join(', ');
        },
        addChild: function (ing) {
            this.ingredient.children_ingredients.push(ing);
        },
        removeChild: function (ing) {
            for (let i in this.ingredient.children_ingredients) {
                if (this.ingredient.children_ingredients[i].id === ing.id) {
                    this.ingredient.children_ingredients.splice(i, 1);
                }
            }
        },
        openLoadingInDiv(id) {
            this.$vs.loading({
                container: '#' + id,
                scale: 0.6
            });
        },
        closeLoadingInDiv(id) {
            this.$vs.loading.close('#' + id + ' > .con-vs-loading')
        },
        fetchData() {
            this.fetchIngredientsFiltered();
        },
        fetchAllData() {
          this.fetchAllIngredients();
        },
        fetchAllIngredients() {
          this.$http.get(process.env.VUE_APP_API_ENDPOINT + '/v1/all-ingredients?filter=' + this.ingredientFilter)
              .then(response => {
                this.allIngredients = response && response.data && response.data.data ? response.data.data.all : [];
                this.isLoadingAll = false;
              });
        },
        fetchUser(userId) {
          let url = process.env.VUE_APP_API_ENDPOINT + '/v1/user/' + userId;
          this.$http.get(url).then(response => {
            this.user_data = response.data.data.data;
            this.dataImg = process.env.VUE_APP_API_ENDPOINT + '/' + response.data.data.logo;
          });
        },
        fetchOne(id) {
            this.openLoadingInDiv('ingredient-container');
            let url = process.env.VUE_APP_API_ENDPOINT + '/v1/ingredients/' + id;
            this.$http.get(url).then(response => {
                this.ingredient = response.data.data;
                this.closeLoadingInDiv('ingredient-container');
            });
        },
        deleteOne(id) {
            let self = this;
            self.toDeleteId = id;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Potwierdź`,
                text: 'Czy na pewno skasować ten składnik?',
                accept: function () {
                    let url = process.env.VUE_APP_API_ENDPOINT + '/v1/ingredients/' + self.toDeleteId;
                    this.$http.delete(url).then(response => {
                        if (response.data.data === true) {
                            this.$vs.notify({
                                color: 'success',
                                title: `Wiadomość`,
                                text: 'Składnik został usunięty',
                            })
                            self.fetchData();
                        }
                    });
                }
            })
        },
        saveIngredient() {
            let postData = this.ingredient;
            this.requestObject = {};

            // add
            if (postData.id === '') {
                delete postData.id;
                this.requestObject = {
                    url: process.env.VUE_APP_API_ENDPOINT + '/v1/ingredients',
                    method: 'post',
                    data: postData
                }
            } else {
                this.requestObject = {
                    url: process.env.VUE_APP_API_ENDPOINT + '/v1/ingredients/' + postData.id,
                    method: 'put',
                    data: postData
                }
            }

            this.$http.request(this.requestObject).then(response => {
                //this.ingredients = response.data.data;
                if (response.data.data === true) {
                    this.$vs.dialog({
                        color: 'success',
                        title: `Wiadomość`,
                        text: 'Składnik został zapisany',
                        accept: this.acceptAlert
                    })
                    //  this.resetForm();
                    this.fetchData();
                } else {
                    this.$vs.dialog({
                        color: 'warning',
                        title: `Błąd`,
                        text: 'Wystąpił błąd podczas zapisywania. Spróbuj jeszcze raz lub skontaktuj się z administratore,',
                        accept: this.acceptAlert
                    })
                }
            });
        },
        fetchIngredientsFiltered() {
            this.openLoadingInDiv('ingredients-container');
            this.$http.get(process.env.VUE_APP_API_ENDPOINT + '/v1/ingredients?q=' + this.search + '&p=' + this.ingredientsPage + '&filter=' + this.ingredientFilter)
                .then(response => {
                    this.ingredients = response.data.data.ingredients;
                    this.ingredientsCount = Math.ceil(response.data.data.count / 10);
                    this.isLoading = false;
                    this.closeLoadingInDiv('ingredients-container');
                });
        },
        resetForm() {
            for (let i in this.ingredient) {
                this.ingredient[i] = '';
            }
            this.ingredient.is_global = false;
            this.ingredient.id = '';

        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.saveIngredient();
                }
            })
        }
    },
    components: {
        'v-select': vSelect,
        InternalIngredientsTree,
    }
}

</script>


<style scoped>
.autocomplete-container {
  position: relative;
}

.autocomplete {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 150px;
  overflow-y: auto;
  background-color: #fff;
  z-index: 1000;
}

.autocomplete div {
  padding: 8px;
  cursor: pointer;
}

.autocomplete div:hover {
  background-color: #f0f0f0;
}

.small-button {
  float: right;
  position: relative;
  z-index: 9999;
  display: flex;
}

.small-button-add {
  margin-top: -38px;
}

.small-button-clear {
  margin-top: -25px;
  margin-right: 8px;
  height: 10px;
}
</style>

